import { Component, Input, OnInit } from '@angular/core';

import { TransitionPromise } from '@uirouter/angular';

import { AppBootstrapService } from 'rev-shared/bootstrap/AppBootstrap.Service';
import { IVideoBasicInfo } from 'rev-shared/media/Media.Contract';
import { setCookie } from 'rev-shared/util/CookieUtil';


import './public-video-password.less';

@Component({
	selector: 'public-video-password',
	host: {
		class: 'primary-background-dark'
	},
	templateUrl: './PublicVideoPassword.Component.html',
	standalone: false
})
export class PublicVideoPasswordComponent implements OnInit {
	@Input() public cookieKey: string;
	@Input() public isPasswordIncorrect: boolean;
	@Input() public loginRedirect: () => void;
	@Input() public submitRedirect: (password?: string) => TransitionPromise;
	@Input() public videoInfo: IVideoBasicInfo;

	public password: string;
	public showPasswordError: boolean;

	constructor(
		private readonly AppBootstrapService: AppBootstrapService
	) { }

	public ngOnInit(): void {
		this.showPasswordError = this.isPasswordIncorrect;
	}

	public onPasswordInputChange(): void {
		this.showPasswordError = false;
	}

	private onTransitionError(): void {
		this.showPasswordError = true;
		this.password = null;
	}

	public submit(): void {
		setCookie(this.cookieKey, this.password);
		if (this.AppBootstrapService.appConfig?.videoPlayerConfig?.isEmbedFullPlayer) {
			this.AppBootstrapService.setAppConfig({ embedPublicVideoPassword: this.password });
		}

		this.submitRedirect(this.password)
			.transition
			.onError(null, () => this.onTransitionError());
	}
}
